<template>
  <div class="product-classification-wrapper">
    <h1>{{ $t("title.product") }}</h1>
    <el-tree
      :data="data"
      :props="defaultProps"
      accordion
      @node-click="handleNodeClick"
      :default-expanded-keys="expandedKeys"
      :current-node-key="selected"
      ref="tree"
      node-key="ID"
      icon-class="el-icon-arrow-right"
    >
      <span
        :class="['custom-tree-node', selected === data.ID ? 'actived' : '']"
        slot-scope="{ node, data }"
      >
        <img v-if="data.PicWebSite" class="icon" :src="data.PicWebSite" />
        <i>{{ node.label }}</i>
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      selected: null,
      expandedKeys: []
    };
  },
  computed: {
    defaultProps() {
      const lang = this.$i18n.locale;
      let data = {
        children: "Childs",
        icon: "icon",
        isLeaf: "leaf"
      };
      if (lang === "zh") {
        data.label = "ItemName";
      } else if (lang === "en") {
        data.label = "EnglishName";
      } else if (lang === "sp") {
        data.label = "xibanyaName";
      }
      return data;
    }
  },
  mounted() {
    const params = {
      Data: {
        ItemParentID: 2
      }
    };
    this.$store
      .dispatch("getProductCategoryData", params)
      .then(res => {
        this.data = res;
        if (this.$route.query.id) {
          const params = {
            Data: {
              ID: this.$route.query.id
            }
          };
          this.$store
            .dispatch("getProductCategoryDetails", params)
            .then(res => {
              this.handleNodeClick(res.Data);
              this.expandedKeys = [res.Data.ItemParentID.toString()];
            });
        } else {
          this.handleNodeClick(res[0]);
        }
      })
      .catch(res => {
        this.$message({
          message: res,
          type: "warning"
        });
      });
  },
  methods: {
    handleNodeClick(data) {
      this.selected = data.ID;
      this.$refs.tree.setCurrentKey(data.ID);
      this.$emit("selectProductCategory", data.ID);
    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.id) {
          const params = {
            Data: {
              ID: this.$route.query.id
            }
          };
          this.$store
            .dispatch("getProductCategoryDetails", params)
            .then(res => {
              this.handleNodeClick(res.Data);
              this.expandedKeys = [res.Data.ItemParentID.toString()];
            });
        } else {
          this.handleNodeClick(this.data[0]);
        }
      }
    },
    deep: true,
    immediate: true
  }
};
</script>

<style lang="less">
@import "~@/assets/style/variables.less";

.product-classification-wrapper {
  width: 285px;

  h1 {
    width: 285px;
    height: 48px;
    background: @bgColor;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 48px;
    color: rgba(255, 255, 255, 1);
    position: relative;
  }

  .el-tree {
    border: 1px solid @borderColor;
    border-top: none;
    padding-bottom: 20px;

    .el-tree-node {
      .el-tree-node__content {
        height: 48px;
        background: none;

        .el-tree-node__expand-icon {
          padding: 0;
          position: absolute;
          right: 20px;
          font-size: 22px;
        }

        .custom-tree-node {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          position: relative;
          padding-left: 60px;

          img {
            width: 28px;
            height: 28px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 20px;
          }

          i {
            width: 100%;
            display: block;
            text-align: left;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            word-wrap: break-word;
          }
        }

        .custom-tree-node:after {
          content: "";
          display: block;
          width: 80%;
          height: 1px;
          background: @borderColor;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }

        .actived {
          i {
            color: @bgColor;
          }
        }

        .actived.custom-tree-node:after {
          content: "";
          display: block;
          width: 80%;
          height: 1px;
          background: @bgColor;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .el-tree-node__children {
      .el-tree-node.is-current {
        .custom-tree-node {
          i {
            color: @bgColor;
          }
        }

        .custom-tree-node:after {
          content: "";
          display: block;
          width: 80%;
          height: 1px;
          background: @bgColor;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
</style>
